// src/components/ScrollTopButton.jsx
import React from "react";
import { useScrollTop } from "../hooks/useScrollTop";

const ScrollTopButton = () => {
  const { showButton, scrollToTop } = useScrollTop();

  return (
    <button
      id="scrollTopBtn"
      className={showButton ? "active" : ""}
      onClick={scrollToTop}
      style={{ display: showButton ? "block" : "none" }}
    >
      <i className="icon-arrow-up"></i>
    </button>
  );
};

export default ScrollTopButton;
